import React from "react";
import Section from "../section/Section";
import cssClass from "./PageTitle.module.scss";

const PageTitle = ({ title }) => (
  <Section className={cssClass.pageTitle}>
    <h1 dangerouslySetInnerHTML={{ __html: title }} />
  </Section>
);

export default PageTitle;
